import { FC } from 'react';
import styles from './DetailedGiveawayActiveInfo.module.scss';
import { TimeDisplay } from '@/utils/TimeDisplay';
import { ReactComponent as HeartIcon } from '@/assets/Icons/heart.svg';
import { ReactComponent as CouponIcon } from '@/assets/Icons/coupon.svg';
import Button from '@/components/Button/Button';
import { GiveawayDetailed } from '@/entities/giveaway/types';
import { useModalStore } from '@/store/ModalStore';

interface DetailedGiveawayActiveInfoProps {
  giveaway: GiveawayDetailed;
}

const DetailedGiveawayActiveInfo: FC<DetailedGiveawayActiveInfoProps> = ({
  giveaway,
}) => {
  const setOpen = useModalStore((state) => state.setOpen);

  return (
    <div className={styles.giveawayDetails}>
      <div className={styles.giveawayTitle}>{giveaway?.name}</div>
      <div className={styles.timeContainer}>
        <TimeDisplay endDate={giveaway?.end_date || ''} format="detail">
          {(timeDetails) => {
            // useEffect(() => {
            //   const updateData = async () => {
            //     if (isExpired) {
            //       await queryClient.invalidateQueries({
            //         queryKey: ['giveaway', Number(id)],
            //       });
            //       const updated = await queryClient.fetchQuery({
            //         queryKey: ['giveaways'],
            //         queryFn: () => fetchGiveaways(),
            //       });
            //       setGiveaways(updated);
            //       console.log('Обновление данных');
            //     }
            //   };
            //   updateData();
            // }, [isExpired]);

            const {
              days = 0,
              hours = 0,
              minutes = 0,
              seconds = 0,
            } = typeof timeDetails === 'string' ? {} : timeDetails;

            return (
              <>
                <div className={styles.timeSquare}>
                  <div className={styles.timeSquareText}>
                    <div className={styles.timeSquareTextTop}>
                      {String(days).padStart(2, '0')}
                    </div>
                    <div className={styles.timeSquareTextBottom}>дней</div>
                  </div>
                </div>
                <div className={styles.spaceDots}>:</div>
                <div className={styles.timeSquare}>
                  <div className={styles.timeSquareText}>
                    <div className={styles.timeSquareTextTop}>
                      {String(hours).padStart(2, '0')}
                    </div>
                    <div className={styles.timeSquareTextBottom}>часов</div>
                  </div>
                </div>
                <div className={styles.spaceDots}>:</div>
                <div className={styles.timeSquare}>
                  <div className={styles.timeSquareText}>
                    <div className={styles.timeSquareTextTop}>
                      {String(minutes).padStart(2, '0')}
                    </div>
                    <div className={styles.timeSquareTextBottom}>минут</div>
                  </div>
                </div>
                <div className={styles.spaceDots}>:</div>
                <div className={styles.timeSquare}>
                  <div className={styles.timeSquareText}>
                    <div className={styles.timeSquareTextTop}>
                      {String(seconds).padStart(2, '0')}
                    </div>
                    <div className={styles.timeSquareTextBottom}>секунд</div>
                  </div>
                </div>
              </>
            );
          }}
        </TimeDisplay>
      </div>
      <div className={styles.currencies}>
        <div className={styles.currencyBox}>
          <div className={styles.currencyBoxTop}>
            <div>{giveaway?.config.entry_fee_price}</div>
            <div>
              {giveaway?.config.entry_fee_type === 'hearts' ? (
                <HeartIcon className={styles.heartIcon} />
              ) : (
                ''
              )}
            </div>
          </div>
          <div className={styles.currencyBoxBottom}>
            Стоимость
            <br />
            Участия
          </div>
        </div>
        <div className={styles.currencyBox}>
          <div className={styles.currencyBoxTop}>
            <div>
              {giveaway?.remaining_coupons}/{giveaway?.available_coupons}
            </div>
            <div>
              <CouponIcon className={styles.heartIcon} />
            </div>
          </div>
          <div className={styles.currencyBoxBottom}>
            Доступные
            <br />
            Билеты
          </div>
        </div>
        <div className={styles.currencyBox}>
          <div className={styles.currencyBoxTop}>
            <div>
              {giveaway?.user_purchased_coupons.quantity}/
              {giveaway?.config.max_coupons_per_user_by_currency.quantity}
            </div>
            <div>
              <CouponIcon className={styles.heartIcon} />
            </div>
          </div>
          <div className={styles.currencyBoxBottom}>
            Твои
            <br />
            Билеты
          </div>
        </div>
      </div>
      <div className={styles.giveawayButton}>
        {giveaway?.user_purchased_coupons?.quantity >= 5 ? (
          <Button disabled>Билеты куплены</Button>
        ) : (
          <Button onClick={() => setOpen(true)}>
            {(giveaway?.user_purchased_coupons?.quantity ?? 0) > 0
              ? 'Докупить'
              : 'Учавствовать'}
          </Button>
        )}
      </div>
    </div>
  );
};

export default DetailedGiveawayActiveInfo;
